const contentWrapperCls = "_275c17pxteg";

export { contentWrapperCls };
import "./_page.style.linaria.module.css";
//# sourceMappingURL=_page.style.js.map
